import { COMPANY_NAME } from 'app-constants';
import { AppRouter } from 'components';
import { Toaster } from 'components/ui/sonner';
import { NativeTranslateObserverContext } from 'context/native-translate-observer-context';
import { useRootContext } from 'context/root';
import { useGetPageTitle } from 'hooks/use-get-page-title';
import { Helmet } from 'react-helmet-async';

export const App = () => {
  const { application } = useRootContext();
  const pageTitle = useGetPageTitle(application);

  return (
    <>
      <Helmet
        title={pageTitle}
        defaultTitle={COMPANY_NAME}
        titleTemplate={`%s | ${COMPANY_NAME}`}
      />
      <NativeTranslateObserverContext>
        <AppRouter />
      </NativeTranslateObserverContext>
      <Toaster />
    </>
  );
};
